import { RedirectLocalStorage } from 'utility/RedirectLocalStorage';
import { getCookie } from './getCookie';
import paths from 'routes/paths';
import { matchPath } from 'react-router';

const REDIRECT_COOKIE = 'kzn_doc_url';
const SESSION_ID_EXPIRES = 'sessionid_expires';

const validRedirectHostname = ['fmo.kizen.com', 'go.kizen.com'];

const isPlainDashboard = (pathString: string) => pathString === '/dashboard';

const matchyMatch = (pathString: string, path: string) =>
  matchPath(pathString, {
    path,
    exact: true,
    strict: false,
  });

export const checkRedirectDomain = () => {
  const hostname = window.location.hostname;

  const localStorage = new RedirectLocalStorage('loginRedirect');
  const redirectHostname = getCookie(REDIRECT_COOKIE);

  if (
    (localStorage.path || isPlainDashboard(localStorage.pathOriginal)) &&
    validRedirectHostname.includes(hostname) &&
    validRedirectHostname.includes(redirectHostname) &&
    hostname !== redirectHostname
  ) {
    // plain '/dashboard' is a special case
    if (isPlainDashboard(localStorage.pathOriginal)) {
      return [redirectHostname, redirectHostname + localStorage.pathOriginal];
    }

    const isMatch = Array.from(paths.values())
      .flat()
      .some((path: any) => matchyMatch(localStorage.path, path));

    return isMatch
      ? [redirectHostname, redirectHostname + localStorage.path]
      : ['', ''];
  }
  return ['', ''];
};

export const setRedirectCookie = () => {
  const hostname = window.location.hostname;
  if (validRedirectHostname.includes(hostname)) {
    let expires;

    const expiresString = getCookie(SESSION_ID_EXPIRES);
    if (expiresString !== '') {
      expires = new Date(expiresString);
    } else {
      expires = new Date();
      expires.setMonth(expires.getMonth() + 3);
    }

    document.cookie = `${REDIRECT_COOKIE}=${hostname};Expires="${expires.toUTCString()}";domain=.kizen.com;Path=/;`;
  }
};

export const deleteRedirectCookie = () => {
  const hostname = window.location.hostname;
  const redirectHostname = getCookie(REDIRECT_COOKIE);
  if (hostname === redirectHostname) {
    document.cookie = `${REDIRECT_COOKIE}=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.kizen.com;Path=/;`;
  }
};
